/** Why a delivery was refused for compliance: its From domain, or email for the whole workspace or account. */
export type SendingDisabledReason = { kind: 'domain'; domain: string | null } | { kind: 'email' };

// Text from services `account_sending_domains.SendingDisabledReasonFor`, `environments.EmailDisabledReason`
// and `send_state.AccountEmailDisabledReason`; each must stay in step with its source.
const DISABLED_DOMAIN_REASON = /^Sending from (?:this domain|(\S+)) has been disabled\. Contact support for details\.$/;
const DISABLED_EMAIL_REASON =
  /^Email sending has been disabled for this (?:workspace|account)\. Contact support for details\.$/;
const ADDRESS_DOMAIN = /@([^\s@<>]+)>?\s*$/;

/** Matches a compliance refusal; a domain one takes its domain from the reason, else from the From address. */
export function sendingDisabledReason(reason: unknown, fromAddress?: string | null): SendingDisabledReason | null {
  if (typeof reason !== 'string') return null;
  const trimmed = reason.trim();
  if (DISABLED_EMAIL_REASON.test(trimmed)) return { kind: 'email' };
  const match = DISABLED_DOMAIN_REASON.exec(trimmed);
  if (match == null) return null;
  return { kind: 'domain', domain: match[1] ?? ADDRESS_DOMAIN.exec(fromAddress ?? '')?.[1] ?? null };
}
